import { render, staticRenderFns } from "./UserSelection.vue?vue&type=template&id=55d0c3fc"
import script from "./UserSelection.vue?vue&type=script&lang=js"
export * from "./UserSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports